import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Bell, Mail, MessageCircle, MessageSquareText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ResolvedChannelValue } from "@/types/chat-external-message";

interface ExternalChannelBadgeProps {
  external?: boolean;
  channel?: ResolvedChannelValue;
}

type BadgedChannel = Exclude<ResolvedChannelValue, "STREAM_ONLY">;

const ICON: Record<BadgedChannel, React.ReactNode> = {
  IN_APP: <Bell className="size-3" aria-hidden />,
  EMAIL: <Mail className="size-3" aria-hidden />,
  SMS: <MessageSquareText className="size-3" aria-hidden />,
  WHATSAPP: <MessageCircle className="size-3" aria-hidden />,
};

export const ExternalChannelBadge: FC<ExternalChannelBadgeProps> = ({
  external,
  channel,
}) => {
  const { t } = useTranslation();
  if (!external || !channel || channel === "STREAM_ONLY") return null;

  return (
    <div className="mt-1">
      <Badge variant="new_secondary" className="gap-1">
        {ICON[channel]}
        {t(`communicationChannels.composer.badge.${channel}`)}
      </Badge>
    </div>
  );
};
